export const validateSession = "get/session";
